export default __webpack_public_path__ + "static/media/mixkit-conference-audience-clapping-strongly-476.56044b6a.wav";